import React, { useState } from "react";
import { Phone, Menu, X, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/data/business";

const NAV = [
  { href: "#offer", label: "Lagan Combo" },
  { href: "#categories", label: "Categories" },
  { href: "#brands", label: "Brands" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/85 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="bg-blue-700 text-white" data-testid="header-topstrip">
        <div className="container-b flex h-9 items-center justify-center text-center">
          <span className="font-heading text-[11px] font-bold uppercase tracking-[0.25em] sm:text-xs">
            Bhadani Electronics and Home Appliances
          </span>
        </div>
      </div>
      <div className="container-b flex h-16 items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2.5"
          data-testid="header-logo"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-blue-700 text-white">
            <Zap className="h-5 w-5" strokeWidth={2.4} />
          </span>
          <span className="font-heading text-base font-extrabold leading-tight sm:text-lg">
            Bhadani <span className="text-blue-700">Electronics</span>
            <span className="ml-1 hidden font-semibold text-slate-500 sm:inline">and Home Appliances</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-blue-700"
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            asChild
            className="rounded-full bg-blue-700 px-5 text-white hover:bg-blue-800"
            data-testid="header-call-btn"
          >
            <a href={`tel:${BUSINESS.phoneRaw}`}>
              <Phone className="mr-2 h-4 w-4" /> {BUSINESS.phone}
            </a>
          </Button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 md:hidden"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white md:hidden" data-testid="mobile-menu">
          <div className="container-b flex flex-col gap-1 py-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-blue-700 px-4 py-2.5 text-sm font-semibold text-white"
              data-testid="mobile-call-btn"
            >
              <Phone className="h-4 w-4" /> {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
